export const SENSOR_BLOCK_PREFIX = 'soiling_sensor_data';

export const isSoilingBlockKey = (key: string): boolean => key === SENSOR_BLOCK_PREFIX || key.startsWith(`${SENSOR_BLOCK_PREFIX}_`);

export const getSoilingBlockKeys = (formData: Record<string, unknown> | null | undefined): string[] =>
  Object.keys(formData || {}).filter(isSoilingBlockKey);
